import { S, Icon } from '../regureStyles';

// ─── Metric Card ─────────────────────────────────────────
const MetricCard = ({ label, value, sub, trend, trendUp, icon, color, flash }) => (
  <div
    className={flash ? 'dash-flash' : ''}
    style={{
      background: '#fff',
      border: `1px solid ${S.borderLight}`,
      borderRadius: 16,
      padding: '20px 22px',
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    }}
  >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 1 }}>{label}</div>
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          background: (color || S.burgundy) + '14',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name={icon} color={color || S.burgundy} size={18} />
      </div>
    </div>
    <div style={{ fontSize: 30, fontWeight: 800, color: S.textPrimary, lineHeight: 1 }}>{value}</div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      {trend !== undefined && (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 12, fontWeight: 600, color: trendUp ? '#10b981' : '#ef4444' }}>
          <Icon name={trendUp ? 'trending-up' : 'trending-down'} color={trendUp ? '#10b981' : '#ef4444'} size={13} />
          {trend}
        </span>
      )}
      <span style={{ fontSize: 12, color: S.textMuted }}>{sub}</span>
    </div>
  </div>
);

export default MetricCard;
